import React from 'react';
import { StintTimeline } from './WeatherHistory';

const SimilarWeatherModal = ({ matches, onClose }) => {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 'var(--radius-lg)',
        width: 640, maxWidth: '95vw', maxHeight: '85vh',
        display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      }} onClick={e => e.stopPropagation()}>
        {/* Header stays put — only the match list below scrolls */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
          padding: '24px 24px 12px', flexShrink: 0,
        }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>
              Similar weather forecasts
            </div>
            <div style={{ fontSize: 12, color: 'var(--c-text-muted)', marginTop: 2 }}>
              {matches.length} templates found
            </div>
          </div>
          <button onClick={onClose} style={{
            padding: '6px 14px', borderRadius: 'var(--radius-sm)',
            background: '#f9fafb', border: '1px solid var(--c-border)',
            color: 'var(--c-text-muted)', cursor: 'pointer', fontSize: 13, flexShrink: 0, marginLeft: 12,
          }}>Close</button>
        </div>

        <div style={{
          display: 'flex', flexDirection: 'column', gap: 16,
          padding: '0 24px 24px', overflowY: 'auto',
        }}>
          {matches.map((m) => (
            <div key={`${m.season}-${m.race}`} style={{
              border: '1px solid var(--c-border)', borderRadius: 'var(--radius-sm)', padding: 12,
            }}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>
                S{m.season} R{m.race} {m.trackName && <span style={{ fontWeight: 400, color: 'var(--c-text-muted)' }}>— {m.trackName}</span>}
              </div>
              <StintTimeline stints={m.stints} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SimilarWeatherModal;
